/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Not_Official_AppInputs */

const fr_help_not_official_app = /** @type {(inputs: Help_Not_Official_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'application officielle de votre réseau de transport.`)
};

const en_help_not_official_app = /** @type {(inputs: Help_Not_Official_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The official application for your transport network.`)
};

/**
* | output |
* | --- |
* | "The official application for your transport network." |
*
* @param {Help_Not_Official_AppInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_not_official_app = /** @type {((inputs?: Help_Not_Official_AppInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Not_Official_AppInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_not_official_app(inputs)
	return en_help_not_official_app(inputs)
});